@if (isFetching) {
  <div class="city-card">
    <div class="city-card__header">
      <figure>
        <ngx-skeleton-loader [theme]="{height: '100%', width: '100%'}"></ngx-skeleton-loader>
      </figure>
    </div>
    <div class="city-card__content">
      <h3 #titleRef>
        ‎<ngx-skeleton-loader [theme]="{height: titleRef.clientHeight + 'px', width: '70%'}"></ngx-skeleton-loader>
      </h3>

      <div class="itinerary-card__row">
        <ngx-skeleton-loader [theme]="{height: '16px', width: '250px'}"></ngx-skeleton-loader>
      </div>
      <div class="itinerary-card__row">
        <ngx-skeleton-loader [theme]="{height: '16px', width: '250px'}"></ngx-skeleton-loader>
      </div>
    </div>

    <div class="city-card__footer">
      <button class="city-card__about btn-default btn-border">
        About
      </button>
      <button class="city-card__cities btn-default btn-border btn-border-active">
        Things to do
      </button>
    </div>
  </div>
} @else {
  @if (city) {
    <div class="city-card">
      <div class="city-card__header">
        <figure>
          <img [src]="city.imageUrl | safeUrl" alt="country-image">
        </figure>
      </div>
      <div class="city-card__content">
        <h3>{{ city.name }}</h3>

        <div class="city-card__row">
          <p class="city-card__description"
             [innerHtml]="city.thingsTodoDescription"></p>
        </div>
      </div>

      <div class="city-card__footer">
        <button [routerLink]="['/', countryName, regionName, city.name]" class="city-card__about btn-default btn-border">
          About
        </button>
        @if(city.isThingsTodo) {
          <button [routerLink]="[getThingsTodoLink(city.name)]" class="city-card__cities btn-default btn-border btn-border-active">
            Things to do
          </button>
        }
      </div>
    </div>
  }
}
